import { EnumAPIKey, EnumMethod } from "@/constant/app";
import { EndpointSetting } from "../../type";
import { callbackGetCategoryList } from "./callbacks/callbackGetCategoryList";

export const StoreEnumEndpoints = {
  GET_STORE_DETAIL: "/stores/store-setting",
  GET_CATEGORY_LIST: "/products/category",
  SEND_MAIL_CONTACT: "/send-mail-personal-submit/",
  DISCOUNT_DETAIL: "/products/discount"
}

export const StoreEnumEndpointsName = {
  GET_STORE_DETAIL: "store_setting",
  GET_CATEGORY_LIST: "category_list",
  SEND_MAIL_CONTACT: "send_mail_contact",
  DISCOUNT_DETAIL: "discount_detail"
} as const

export type TypeStoreEndpointsName = typeof StoreEnumEndpointsName[keyof typeof StoreEnumEndpointsName]

export type StoreEndpoints = {
  [K in TypeStoreEndpointsName]: EndpointSetting
}

export const storeEndpoints: StoreEndpoints = {
  discount_detail: {
    method: EnumMethod.GET,
    endpoint: StoreEnumEndpoints.DISCOUNT_DETAIL,
    api: EnumAPIKey.API_BASE
  },
  store_setting: {
    method: EnumMethod.GET,
    endpoint: StoreEnumEndpoints.GET_STORE_DETAIL,
    api: EnumAPIKey.API_BASE
  },
  send_mail_contact: {
    method: EnumMethod.POST,
    endpoint: StoreEnumEndpoints.SEND_MAIL_CONTACT,
    api: EnumAPIKey.API_BASE
  },
  category_list: {
    method: EnumMethod.GET,
    endpoint: StoreEnumEndpoints.GET_CATEGORY_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetCategoryList
  }
}